import { useEffect, useState } from "react";
import { haptics as haptic } from "@/lib/haptics";

const THRESHOLD_TOAST_MS = 5_000;
export function useNativeThreshold(): number | null {
  const [mark, setMark] = useState<number | null>(null);
  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;
    const crossed = (event: Event): void => {
      const value: unknown = (event as CustomEvent<unknown>).detail;
      if (value !== 80 && value !== 100) return;
      haptic("warning");
      setMark(value);
      clearTimeout(timer);
      timer = setTimeout(() => setMark(null), THRESHOLD_TOAST_MS);
    };
    window.addEventListener("tally:budget-threshold", crossed);
    return () => { clearTimeout(timer); window.removeEventListener("tally:budget-threshold", crossed); };
  }, []);
  return mark;
}
